import { Link } from 'react-router-dom';

const PageNotFound = () => (
  <>
    {/* <Helmet>
      <title>404 - Page Not Found </title>
      <meta name="description" content="Sorry, the page you're looking for doesn't exist. Find what you need from our homepage or search." />
      <meta name="robots" content="noindex, follow" />
      <link rel="canonical" href={`${window.location.origin}/404`} />
    </Helmet> */}
    
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '0 1rem'
    }}>
      <h1 style={{ 
        fontSize: '6rem', 
        margin: 0,
        color: '#333',
        fontWeight: 'bold'
      }}>404</h1>
      
      <h2 style={{ 
        fontSize: '1.5rem',
        margin: '1rem 0',
        color: '#666'
      }}>
        Oops! Page Not Found
      </h2>
      
      <p style={{ 
        fontSize: '1rem',
        color: '#888',
        maxWidth: '400px',
        lineHeight: '1.5'
      }}>
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>


      {/* Navigation links */}
      <div style={{ 
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        <Link 
          to="/" 
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#1976d2',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            fontWeight: 'bold',
            transition: 'background-color 0.3s'
          }}
        >
          Go to Home
        </Link>
        
      </div>

    </div>
  </>
);

export default PageNotFound;
